export const CommunicationSVG = (props) => (
  <svg
    height={40}
    viewBox="0 0 40 40"
    width={40}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd" stroke="#020203" strokeWidth={1.2}>
      <path d="M28.85 21.094c.088-.235.17-.473.244-.714l2.754-.646v-6.487l-2.754-.645a13.107 13.107 0 00-.937-2.258l1.489-2.4-4.587-4.587-2.395 1.485a13.096 13.096 0 00-2.278-.948l-.644-2.745h-6.487l-.644 2.745c-.79.244-1.547.562-2.266.942L7.938 3.343 3.35 7.93l1.493 2.407c-.38.718-.698 1.475-.941 2.265l-2.754.645v6.487l2.754.646c.245.794.561 1.55.945 2.272L3.35 25.065l4.587 4.586 2.418-1.5c.723.384 1.456.69 2.252.935l.647 2.762h5.233" />
      <path d="M18.488 25.964a9.722 9.722 0 01-1.99.205c-5.34 0-9.67-4.33-9.67-9.67 0-5.341 4.33-9.671 9.67-9.671 5.341 0 9.67 4.33 9.67 9.67 0 1.664-.419 3.229-1.158 4.595" />
      <path d="M19.936 16.498a3.438 3.438 0 11-6.875 0 3.438 3.438 0 016.875 0zM18.488 39.128h20.455V21.093H18.488zM18.488 24.578h20.455" />
      <path d="M22.764 29.238l1.64 1.687 3.607-3.42M22.764 34.43l1.64 1.686 3.607-3.42" />
    </g>
  </svg>
);
